module.exports = __webpack_public_path__ + "static/media/newDatePicker.be7c11d1.svg";